import { cn } from '@/lib/utils';
import { GoodRuleCard } from '@/pages/pii-training/GoodRuleCard';
import {
  consentBoxClassName,
  consentBoxDoneClassName,
  consentBoxPendingClassName,
  consentCheckboxClassName,
} from '@/pages/pii-training/piiTraining.styles';
import type { FormStepProps } from '@/pages/pii-training/piiTraining.types';
import { Checkbox, Label, Stack, Text } from '@careflux/primitives';
import { Controller } from 'react-hook-form';

export const ConsentStep = ({ copy, control }: FormStepProps) => (
  <Stack as="section" gap="lg">
    <GoodRuleCard title={copy.combinations.goodRuleTitle} body={copy.combinations.goodRuleBody} />
    <Controller
      name="consented"
      control={control}
      render={({ field }) => (
        <div className={cn(consentBoxClassName, field.value ? consentBoxDoneClassName : consentBoxPendingClassName)}>
          <Checkbox
            id="consent"
            checked={field.value}
            onCheckedChange={(checked) => field.onChange(checked === true)}
            className={consentCheckboxClassName}
          />
          <Label htmlFor="consent">
            <Text>{copy.consent.consentLabel}</Text>
          </Label>
        </div>
      )}
    />
  </Stack>
);
